const SECURE_SIMPLEPRACTICE_SIGNIN =
  "https://secure.simplepractice.com/users/sign_in";

export default SECURE_SIMPLEPRACTICE_SIGNIN;
